import React from 'react';
import cx from 'classnames';
import { Container, Title } from './styles';
export const Description = (props) => {
    return (React.createElement(Container, { className: cx('description', props.className), "data-role": "description" },
        React.createElement(Title, { className: "description-title", "data-role": "description-title" }, props.title),
        React.createElement("dd", { className: "description-content", "data-role": "description-content" }, props.content)));
};
